<template>
  <g transform="scale(1.4)" id="gmain">
    <Tooth
      v-for="i in tooths"
      :key="i"
      :number="i"
      :positionY="y"
      :positionX="Math.abs((i - start ) * 32) + x"
    />
    
  </g>
</template>

<script>
import Tooth from './Tooth.vue';

export default {
  name: 'Teeth',
  components: {
    Tooth
  },
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    }
  },
  computed: {
    tooths() {
      return this.getArray(this.start, this.end);
    }
  },
  methods: {
    getArray(start, end) {
      const list = [];
      if (start > end) {
        for (let i = start; i >= end; i--) {
          list.push(i);
        }
      } else {
        for (let i = start; i <= end; i++) {
          list.push(i);
        }
      }
      return list;
    },
  
  }
};
</script>
